import React from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "../styles/components/CKEditorWrapper.css";

interface CKEditorWrapperProps {
  value: string;
  onChange: (content: string) => void;
  placeholder?: string;
  minLength?: number;
  className?: string;
}

/**
 * Component wrapper cho CKEditor để tái sử dụng
 * 
 * @param value - Nội dung hiện tại của editor
 * @param onChange - Callback khi nội dung thay đổi
 * @param placeholder - Placeholder text (mặc định: "Viết nội dung bài viết chất lượng, ít nhất 100 ký tự......")
 * @param minLength - Độ dài tối thiểu để hiển thị trong hint (mặc định: 100)
 * @param className - CSS class cho editor
 */
const CKEditorWrapper: React.FC<CKEditorWrapperProps> = ({
  value,
  onChange,
  placeholder = "Viết nội dung bài viết chất lượng, ít nhất 100 ký tự......",
  minLength = 100,
  className = "article-content_textarea",
}) => {
  // Tính số ký tự (loại bỏ HTML tags)
  const textLength = value.replace(/<[^>]*>/g, "").length;

  return (
    <div className="ckeditor-wrapper">
      <style>{`
        .ckeditor-wrapper .ck-powered-by,
        .ckeditor-wrapper .ck-powered-by-balloon,
        .ckeditor-wrapper [class*="ck-powered-by"],
        .ckeditor-wrapper [class*="powered-by"],
        .ck-powered-by,
        .ck-powered-by-balloon,
        [class*="ck-powered-by"],
        [class*="powered-by"] {
          display: none !important;
          visibility: hidden !important;
          opacity: 0 !important;
          height: 0 !important;
          width: 0 !important;
          margin: 0 !important;
          padding: 0 !important;
        }
      `}</style>
      <div className={className}>
        <CKEditor
          // @ts-ignore - CKEditor 5 React wrapper có type chưa hoàn hảo với build classic
          editor={ClassicEditor}
          data={value}
        config={{
          placeholder,
          language: "vi",
          toolbar: [
            "heading",
            "|",
            "bold",
            "italic",
            "link",
            "bulletedList",
            "numberedList",
            "|",
            "outdent",
            "indent",
            "|",
            "blockQuote",
            "insertTable",
            "undo",
            "redo",
          ],
          link: {
            decorators: {
              openInNewTab: {
                mode: "manual",
                label: "Mở trong tab mới",
                attributes: {
                  target: "_blank",
                  rel: "noopener noreferrer",
                },
              },
            },
            addTargetToExternalLinks: true,
            defaultProtocol: "https://",
          },
        }}
        onChange={(_event: any, editor: any) => {
          const data = editor.getData();
          onChange(data);
        }}
        />
      </div>
      <div style={{ textAlign: "right", marginTop: "8px" }}>
        <span
          className={`article-content_hint ${
            textLength < minLength ? "hint-error" : ""
          }`}
        >
          {textLength}/{minLength} ký tự tối thiểu
        </span>
      </div>
    </div>
  );
};

export default CKEditorWrapper;

